module.exports = __webpack_public_path__ + "static/img/section-3.f952b21.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/section-3.gif
// module id = j3DK
// module chunks = 1